// @ts-ignore
if (!('CustomEvent' in window &&
    // In Safari, typeof CustomEvent == 'object' but it otherwise works fine
    // @ts-ignore
    (typeof window.CustomEvent === 'function' || (window.CustomEvent.toString().indexOf('CustomEventConstructor') > -1))
)) {
    // @ts-ignore
    const CustomEvent = function (event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    };

    // @ts-ignore
    CustomEvent.prototype = window.Event.prototype;

    // @ts-ignore
    window.CustomEvent = CustomEvent;
}
